<template>
  <el-dialog title="部门筛选" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <div class="tree_filter">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          <el-button slot="append" icon="el-icon-search" @click="filterkeyword"></el-button>
        </el-input>
      </div>
      <div class="search_result" v-if="!treeflag">
        <p>共有 {{count}}个搜索结果</p>
        <ul>
          <li v-for="(item,index) in result" :key="index" @click.stop="checksearch(item)">{{item.name}}</li>
        </ul>
      </div>
      <el-tree
        v-if="treeflag"
        class="filter-tree"
        :props="props"
        :load="loadNode"
        lazy
        ref="tree"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "chooseDepDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      filterText: "",
      count: "",
      result: [],
      treeflag: true,
      props: {
        label: "name",
        children: "zones",
        isLeaf: "leaf"
      }
    };
  },
  created() {
    this.querydep();
  },
  methods: {
    // 关键字查询
    filterkeyword() {
      if (this.filterText == "") {
        this.treeflag = true;
      } else {
        this.treeflag = false;
        let params = {
          name: this.filterText
        };
        this.axios
          .post(api.department_searchs, params)
          .then(response => {
            if (response.data.code == 0) {
              this.count = response.data.count;
              this.result = response.data.list || [];
            } 
          })
          .catch(() => {});
      }
    },
    // 懒加载
    async loadNode(node, resolve) {
      if (node.level === 0 || node.level === 1) {
        let res = await this.querydep();
        if (res && res.data.code === 0) {
          if (node.level === 0) {
            return resolve([
              { name: res.data.info.name, id: res.data.info.id }
            ]);
          } else {
            let deplist = res.data.info.list || [];
            return resolve(deplist);
          }
        } else {
          return resolve([]);
        }
      }
      if (node.level > 1) {
        let id = node.data.id;
        let childres = await this.querychilddep(id);
        if (childres && childres.data.code === 0) {
          let childdep = childres.data.list || [];
          return resolve(childdep);
        } else {
          return resolve([]);
        }
      }
    },

    // 查询部门
    querydep() {
      let params = {};
      return this.axios.post(api.department_index, params);
    },
    // 查询子部门
    querychilddep(id) {
      let params = {
        depart_id: id
      };
      return this.axios.post(api.department_getchild, params);
    },
    handleNodeClick(data) {
      this.$emit("choosedepsucess", { name: data.name, id: data.id });
      this.dialogVisible = false;
    },
    checksearch(data) {
      this.$emit("choosedepsucess", { name: data.name, id: data.id });
      this.dialogVisible = false;
    }
  }
};
</script>

